// extracted by mini-css-extract-plugin
export default {"tasks":"lO-z","task":"mO-z","svg":"nO-z","text":"oO-z"};